<template>
    <canvas id="revenue-chart" width="90%" height="80%"></canvas>
</template>

<script>
    export default {
        props: ['revenue'],
        name: "admin-dash-revenue-graph",
        watch: {
            revenue: function () {
                this.drawChart();
            }
        },
        methods: {
            getGraphData: function () {
                let graphDataArray = [];

                this.revenue.forEach(function (element) {
                    let tempDate = new Date(element.date);

                    graphDataArray.push({
                        x: tempDate,
                        y: element.revenue
                    });
                });

                return graphDataArray;
            },
            drawChart: function () {
                let graphElement = $("#revenue-chart");
                let options = {
                    tooltips: {
                        mode: 'index',
                        callbacks: {
                            title: function (tooltipItem, chart) {
                                let returnString = new Date(tooltipItem[0].xLabel).toLocaleDateString(window.navigator.language, {
                                    weekday: 'long',
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                });
                                return returnString;
                            },
                            label: function (tooltipItem, data) {
                                return number_format_no_zero_decimals(tooltipItem.yLabel, 2, ", ", " ") + " kr";
                            },
                        }
                    },
                    responsive: true,
                    scales: {
                        yAxes: [{
                            id: 'C',
                            ticks: {
                                beginAtZero: true,
                                callback: function (value, index, values) {
                                    return number_format_no_zero_decimals(value, 2, ",", " ") + " kr";
                                }
                            },
                            offset: true,
                        }],
                        xAxes: [{
                            type: 'time',
                            positive: 'bottom',
                            time: {
                                unit: 'day'
                            }
                        }]
                    }
                };

                let data = this.getGraphData();

                let occupancyChart  = new Chart(graphElement, {
                    type: 'line',
                    data: {
                        datasets: [{
                            label: 'Omsättning i SEK',
                            data: data,
                            backgroundColor: 'rgba(255, 99, 132, 0.2)',
                            borderColor: 'rgba(255,99,132,1)',
                            borderWidth: 2
                        },
                        ]
                    },
                    options: options
                });

            }
        }, //methods
        mounted: function () {
            this.drawChart();
        }
    }
</script>

<style scoped>

</style>